import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createPaymentType",
    serviceName: "admin",
    query: gql`
      mutation createPaymentType(
        $title: String!
        $details: String
      ) {
        createPaymentType(
          title: $title
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
